// extracted by mini-css-extract-plugin
module.exports = {"text":"discovery-phase-steps-section_text__Ek6uC","container":"discovery-phase-steps-section_container__D_shW"};